import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { claimingProviders, selectProviders, } from '#pplx/frontend/composer-sdk/internal/typeahead/arbitration.js';
import { useCallback, useRef } from 'react';
/** Checks whether the providers allow a typed trigger before matching its query. */
export function useTypedTriggerLifecycle({ editor, providers, }) {
    const decisionRef = useRef(null);
    const resolveProviders = useCallback(({ prefix, query }) => {
        // The persistent path can observe the final editor update during unmount too.
        if (editor.getRootElement() === null)
            return EMPTY_ARRAY;
        if (prefix !== '') {
            const callbacks = [
                ...new Set(selectProviders(providers, prefix).flatMap((provider) => provider.onTrigger === undefined ? EMPTY_ARRAY : [provider.onTrigger])),
            ];
            const editorState = editor.getEditorState();
            const previous = decisionRef.current;
            const sameCheck = previous?.editorState === editorState &&
                previous.prefix === prefix &&
                previous.query === query &&
                previous.callbacks.length === callbacks.length &&
                previous.callbacks.every((callback, index) => callback === callbacks[index]);
            // Both menu paths check the same update. Share its veto decision so providers hear
            // about the trigger once, even if the persistent path checks it before Lexical does.
            const allowed = sameCheck
                ? previous.allowed
                : allowsTypedTrigger({ callbacks, prefix, query });
            decisionRef.current = { editorState, prefix, query, callbacks, allowed };
            if (!allowed)
                return EMPTY_ARRAY;
        }
        return claimingProviders(providers, prefix, query);
    }, [editor, providers]);
    return { resolveProviders };
}
/** @returns `false` if any provider rejects the trigger; otherwise `true`. */
function allowsTypedTrigger({ callbacks, prefix, query, }) {
    // Every provider must hear about the trigger, even when an earlier callback rejects it.
    const decisions = callbacks.map((callback) => callback(prefix, query));
    return decisions.every((result) => result !== false);
}
//# sourceMappingURL=useTypedTriggerLifecycle.js.map